// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"f440ba5f","796":"934886df"}[chunkId] + ".chunk.js";
};